<div class="center-items center-text margin-top-s">
  <responsive-img [withUpload]="withUploadPhoto" (upload)="uploadPhotoFromGallery($event)" [photoUrl]="photoUrlContent"
    class="border-radius" [customClass]="customClass">
  </responsive-img>
  <!-- <edit-button *ngIf="withUploadPhoto && withUploadPhotoBtn" [icon]="appIconsStandard.pickPhoto" [custom]="false"
    (buttonClick)="uploadPhotoFromGallery($event)" class="margin-top-s">
    <inner-content>Upload photo</inner-content>
  </edit-button> -->
</div>